var _metadata, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPackages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    height: 800,
    width: 800,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M 0,600 H 600 V 0 H 0 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,800)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18)",
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(442.5302,381.9136)",
    id: "g20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -115.323,75.524 72.279,58.474 116.137,-72.281 z m 60.91,-87.711 -110.45,-73.9 -64.968,49.531 L 0.003,-39.8 Z M 2.437,-214.404 -127.508,-288.312 v 146.183 l 67.407,-51.976 c 2.789,-2.153 6.224,-3.297 9.747,-3.249 3.149,-0.065 6.251,0.781 8.932,2.435 l 43.856,29.237 z m -292.37,49.54 45.48,-30.049 c 5.685,-4.061 12.995,-3.249 18.68,0.812 l 65.782,50.352 v -143.752 l -129.942,73.092 z m 4.061,125.068 114.51,-71.468 -64.971,-49.54 -110.45,73.9 z m -73.092,100.7 116.135,72.28 72.28,-58.474 -115.324,-74.715 z m 330.539,-80.4 -113.7,-71.468 -113.7,71.468 113.7,73.9 z m 145.372,83.65 c 0,4.873 -3.249,9.746 -7.308,12.994 l -145.373,90.147 c -5.686,4.061 -13.807,3.249 -18.68,-0.812 l -88.523,-71.468 -88.522,71.468 c -5.686,4.061 -12.995,4.873 -18.68,0.812 l -144.56,-90.147 c -4.513,-2.781 -7.275,-7.692 -7.309,-12.994 0,-4.873 1.624,-10.558 5.685,-13.806 l 83.65,-69.844 -72.28,-56.849 c -4.183,-3.351 -6.582,-8.447 -6.5,-13.805 0,-4.873 3.249,-9.746 7.309,-12.995 l 66.601,-44.667 c -3.249,-3.249 -5.686,-7.309 -5.686,-12.182 v -64.97 c 0,-5.684 3.25,-10.557 8.122,-13.806 l 163.238,-92.583 c 2.432,-1.543 5.242,-2.385 8.121,-2.436 2.896,-0.065 5.739,0.787 8.121,2.436 l 161.619,92.581 c 4.873,3.249 8.121,8.121 8.121,13.805 v 79.59 l 63.347,42.231 c 4.061,3.25 7.31,7.309 7.31,12.994 -0.092,5.32 -2.458,10.346 -6.5,13.806 l -71.468,56.849 83.649,70.656 c 4.871,3.249 6.496,8.122 6.496,12.995"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPackages);
export default __webpack_public_path__ + "static/media/icon-packages.05904557a954297340df6436dc0e024f.svg";
export { ForwardRef as ReactComponent };